import { useContext } from 'react';

import EnvCropsFailedOrdersContext from './EnvCropsFailedOrdersContext';

const useEnvCropsFailedOrders = () => {
  return useContext(EnvCropsFailedOrdersContext);
};

export default useEnvCropsFailedOrders;
